import React, { useCallback, useMemo, useRef } from 'react';
import { Typography } from 'fronton-react';
import { useSelector } from 'react-redux';
import { cx } from 'linaria';
import { useTranslation } from 'react-i18next';
import { handleScrollTo } from 'utils/handle-scroll-to';
import { BrandsFilter } from '../brands-filter';
import { content, contentWithCharSelected, heading } from './styles';
import { BrandsListItem } from '../brands-list-item';
import { getBrands, getBrandsByChar, getBrandsByRange } from './ducks/get-brands';
import { getBrandsFilter } from '../brands-filter/ducks/selectors';
import { BrandsGroup } from './types';

export const AllBrands: React.FC = () => {
  const { t } = useTranslation();
  const brands = useSelector(getBrands) || {};
  const [activeGroup, activeChar] = useSelector(getBrandsFilter);
  const brandsByRange = useSelector(getBrandsByRange(activeGroup as BrandsGroup));
  const brandsByChar = useSelector(getBrandsByChar(activeChar));

  const brandsContainerRef = useRef<null | HTMLDivElement>(null);
  const scrollToBrandsContainer = useCallback(() => {
    handleScrollTo(brandsContainerRef);
  }, []);

  const listItems = useMemo(() => {
    const selectionCondition = activeChar ? brandsByChar : brandsByRange || {};
    return Object.entries(selectionCondition).map(([key, value]) => (
      <BrandsListItem key={key} title={key} items={value} scrollCallback={scrollToBrandsContainer} />
    ));
  }, [activeChar, brandsByChar, brandsByRange, scrollToBrandsContainer]);

  const classNames = !activeChar ? content : cx(content, contentWithCharSelected);

  return Object.keys(brands).length ? (
    <div data-qa="brands-container" ref={brandsContainerRef}>
      <Typography className={heading} variant="h2">
        {t('allBrands')}
      </Typography>
      <BrandsFilter scrollCallback={scrollToBrandsContainer} />
      <div className={classNames}>{listItems}</div>
    </div>
  ) : null;
};
